module.exports = __webpack_public_path__ + "static/media/paper_mountains.955aca3d.jpg";